'use strict';

var DataExtractCustomRenderersFactory = function DataExtractCustomRenderersFactory($interpolate) {
  var dataExtractStatusIcons = {
    'true': $interpolate(require('../templates/custom-renderers/status-success.html')),
    'false': $interpolate(require('../templates/custom-renderers/status-fail.html'))
  };
  var dataExtractStatusRenderer = function dataExtractStatusRenderer(columnContext, row, columnfield, value, defaultvalue) {
    var data = {
      uid: row,
      fieldId: columnfield
    };
    return defaultvalue.replace('>' + value + '<', '>' + dataExtractStatusIcons[value](data) + '<');
  };
  return {
    dataExtractStatus: dataExtractStatusRenderer
  };
};
DataExtractCustomRenderersFactory.$inject = ['$interpolate'];
module.exports = DataExtractCustomRenderersFactory;